import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {SecurityService} from '../../services/security/security.service';
import {User} from '../../types/security/user';

@Directive({
  selector: '[gsShowIfHasPermission]'
})
export class ShowIfHasPermissionDirective implements OnInit {

  @Input()
  gsShowIfHasPermission: string[];

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('gsShowIfHasPermissionConsultantId')
  consultantId: number;

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private securityService: SecurityService) { }

  ngOnInit() {
    // check consultant id against logged user
    if (this.consultantId) {
      this.securityService.getLoggedUser().subscribe(
        (user: User) => {
          if (user.consultantId === this.consultantId) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          } else {
            this.showByPermissions();
          }
        });
    } else {
      this.showByPermissions();
    }
  }

  /**
   * Show/Hide element by user role permissions
   */
  private showByPermissions() {

    if (this.gsShowIfHasPermission.includes('PUBLIC')) {
      this.securityService.isAuthenticated().subscribe(value => {
        if (!value) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.checkIfHasAnyPermission();
        }
      });
    } else {
      this.checkIfHasAnyPermission();
    }
  }

  private checkIfHasAnyPermission() {
    this.securityService.hasAnyPermission(this.gsShowIfHasPermission).subscribe(
      (hasPermission: boolean) => {
        if (hasPermission) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }

}
